import _ from 'lodash'
import { useEffect, useState } from 'react'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** ICON || IMAGE */

/** COMPONENT */

import { Box } from '@mui/material'

import { fileUrl } from 'api/api'
import ClinicApi from 'api/master/clinic.api'
import ProductInstructionsApi from 'api/setting/default-products/product-instruction.api'
import ProductSymptomApi from 'api/setting/default-products/product-symptom'
import ProductUnitsApi from 'api/setting/default-products/product-unit.api'
import ProductUsesApi from 'api/setting/default-products/product-use.api'
import ProductWarningsApi from 'api/setting/default-products/product-warning.api'
import ModalCustom from 'component/ModalCustom/ModalCustom'
import TextInput from 'new-components/inputs/text-input'

/** INTERFACE */
interface TemplateDoctorNote {
    url: any
}
export interface PopupManageProductAddFormProps {
    isShow: boolean
    type: 'PRODUCT_SYMPTOM' | 'PRODUCT_USES' | 'PRODUCT_UNITS' | 'PRODUCT_INSTRUCTION' | 'PRODUCT_WARNING'
    items: any
    maxLength?: any
    onInsert?: (img: HTMLImageElement) => void
    onCancel?: () => void
    onSubmit: (data: any, type: any) => void
}

export function PopupManageProductAddForm(props: PopupManageProductAddFormProps) {
    const { t } = useTranslation()

    const [templateDoctorNotes, setTemplateDoctorNotes] = useState<TemplateDoctorNote[]>([])
    const [name, setName] = useState<any>('')
    const [nameEn, setNameEn] = useState<any>('')
    const [errorName, setErrorName] = useState<any>()

    const [textLength, setTextLength] = useState<number>(0)
    const [textLengEn, setTextLengEn] = useState<number>(0)
    const [errorMaxLength, setErrorMaxLength] = useState<boolean>(false)

    const loadData = async () => {
        await ClinicApi.allTemplateDoctorNote().then((res: any) => {
            setTemplateDoctorNotes([...res.data.map((img: any, i: any) => ({ url: `${fileUrl}/${img.url}` }))])
        })
    }

    const replaceUrlToBase64 = () => {
        setTimeout(() => {
            _.map(templateDoctorNotes, async (templateDoctorNote: any, i: any) => {
                const editImg: any = document.getElementById(`template-IMAGE_${i}`)
                if (editImg)
                    toDataUrl(templateDoctorNote.url, (myBase64: any) => {
                        editImg.src = myBase64
                    })
            })
        }, 1000)
    }

    useEffect(() => { replaceUrlToBase64() }, [templateDoctorNotes])

    useEffect(() => {
        if (props.isShow) {
            loadData()
            // Reset form when modal opens
            setName('')
            setNameEn('')
            setErrorName('')
            setTextLength(0)
            setTextLengEn(0)
            setErrorMaxLength(false)
        }
    }, [props.isShow])

    const handleTitle: any = () => {
        if (props.type === 'PRODUCT_INSTRUCTION') {
            return `${t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.ADD_PRODUCT_INSTRUCTION')}`
        }
        if (props.type === 'PRODUCT_UNITS') {
            return `${t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.ADD_PRODUCT_UNIT')}`
        }
        if (props.type === 'PRODUCT_USES') {
            return `${t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.ADD_PRODUCT_USE')}`
        }
        if (props.type === 'PRODUCT_SYMPTOM') {
            return `${t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.ADD_SYMPTOM')}`
        }
        if (props.type === 'PRODUCT_WARNING') {
            return `${t('เพิ่มข้อควรระวัง')}`
        }
    }

    const handleLabelTh: any = () => {
        if (props.type === 'PRODUCT_INSTRUCTION') {
            return `${t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.PRODUCT_INSTRUCTION')}`
        }
        if (props.type === 'PRODUCT_UNITS') {
            return `${t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.PRODUCT_UNIT')}`
        }
        if (props.type === 'PRODUCT_USES') {
            return `${t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.PRODUCT_USE')}`
        }
        if (props.type === 'PRODUCT_SYMPTOM') {
            return `${t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.SYMPTOM')}`
        }
        if (props.type === 'PRODUCT_WARNING') {
            return `${t('ข้อควรระวัง')}`
        }
    }

    const handleLabelEn: any = () => {
        if (props.type === 'PRODUCT_INSTRUCTION') {
            return `${t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.PRODUCT_INSTRUCTION_EN')}`
        }
        if (props.type === 'PRODUCT_UNITS') {
            return `${t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.PRODUCT_UNIT_EN')}`
        }
        if (props.type === 'PRODUCT_USES') {
            return `${t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.PRODUCT_USE_EN')}`
        }
        if (props.type === 'PRODUCT_SYMPTOM') {
            return `${t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.SYMPTOM_EN')}`
        }
        if (props.type === 'PRODUCT_WARNING') {
            return `${t('MEDICINE_WARNING.INPUT.PRODUCT_WARNING_NAME_EN')}`
        }
    }
    const handleChangeName = (e: any) => {
        setErrorName('')
        const name = e.target.value === '' ? '' : String(e.target.value)
        const contentLength = name.length

        if (!props.maxLength || props.maxLength === 0) {
            setName(name)
            setTextLength(contentLength)
            setErrorMaxLength(false)
        } else if (contentLength > props.maxLength) {
            setErrorMaxLength(true)
        } else {
            setName(name)
            setTextLength(contentLength)
            setErrorMaxLength(false)
        }

    }
    const handleChangeNameEn = (e: any) => {
        const nameEn = e.target.value === '' ? '' : String(e.target.value)
        const contentLength = nameEn.length
        if (!props.maxLength || props.maxLength === 0) {
            setNameEn(nameEn)
            setTextLengEn(contentLength)
            setErrorMaxLength(false)

        } else if (contentLength > props.maxLength) {
            setErrorMaxLength(true)
        } else {
            setNameEn(nameEn)
            setTextLengEn(contentLength)
            setErrorMaxLength(false)
        }

    }

    const toDataUrl = async (url: any, callback: any) => {
        const xhr = new XMLHttpRequest()

        xhr.onload = function () {
            const reader = new FileReader()
            reader.onloadend = function () {
                callback(reader.result)
            }
            reader.readAsDataURL(xhr.response)
        }
        xhr.open('GET', url)
        xhr.responseType = 'blob'
        xhr.send()
    }


    const submit = async () => {
        if (!name) return setErrorName(t('TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MESSAGE.ERROR.EMPTY_NAME'))
        if (props.type === 'PRODUCT_INSTRUCTION') {
            await ProductInstructionsApi
                .create({ group: 'MEDICINE', productInstructionName: name, productInstructionNameEn: nameEn })
                .then(({ data }) => {
                    setName('')
                    setNameEn('')
                    props.onSubmit(data, props.type)
                })
                .catch((e) => {
                    const err = e.response.data
                    return setErrorName(t(`TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MESSAGE.ERROR.${err.message}`))
                })
        }
        if (props.type === 'PRODUCT_UNITS') {
            await ProductUnitsApi
                .create({ group: 'MEDICINE', productUnitName: name, productUnitNameEn: nameEn })
                .then(({ data }) => {
                    setName('')
                    setNameEn('')
                    props.onSubmit(data, props.type)
                })
                .catch((e) => {
                    const err = e.response.data
                    return setErrorName(t(`TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MESSAGE.ERROR.${err.message}`))
                })
        }
        if (props.type === 'PRODUCT_USES') {
            await ProductUsesApi
                .create({ group: 'MEDICINE', productUseDetail: name, productUseDetailEn: nameEn })
                .then(({ data }) => {
                    setName('')
                    setNameEn('')
                    props.onSubmit(data, props.type)
                })
                .catch((e) => {
                    const err = e.response.data
                    return setErrorName(t(`TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MESSAGE.ERROR.${err.message}`))
                })
        }
        if (props.type === 'PRODUCT_SYMPTOM') {
            await ProductSymptomApi
                .create({ group: 'MEDICINE', detail: name, detailEn: nameEn })
                .then(({ data }) => {
                    setName('')
                    setNameEn('')
                    props.onSubmit(data, props.type)
                })
                .catch((e) => {
                    const err = e.response.data
                    return setErrorName(t(`TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MESSAGE.ERROR.${err.message}`))
                })
        }
        if (props.type === 'PRODUCT_WARNING') {
            await ProductWarningsApi
                .postCreateProductWarning({ group: 'MEDICINE', productWarningName: name, productWarningNameEn: nameEn })
                .then(({ data }) => {
                    setName('')
                    setNameEn('')
                    props.onSubmit(data, props.type)
                })
                .catch((e) => {
                    const err = e.response.data
                    return setErrorName(t(`TREATMENT_SUMMARY.POPUP.MANAGE_PRODUCT.MESSAGE.ERROR.${err.message}`))
                })
        }


    }

    return props.isShow ? (
        <ModalCustom
            size={'lg'}
            title={handleTitle()}
            alignFooter={'end'}
            fullscreen={'sm-down'}
            component={
                <>
                    {props.maxLength > 0 ? <Box sx={{ fontWeight: 400, fontSize: '10px', color: '#808080', textAlign: 'end', marginLeft: '10px' }}>{`${textLength}/${props.maxLength}`}</Box> : <></>}
                    <TextInput
                        required
                        helperText={errorName}
                        label={handleLabelTh()}
                        value={name}
                        onChange={handleChangeName}
                        fullWidth
                        focus={true}
                        maxLength={props.maxLength > 0 ? props.maxLength : 1000}
                    />
                    {props.maxLength > 0 ? <Box sx={{ fontWeight: 400, fontSize: '10px', color: '#808080', textAlign: 'end', marginLeft: '10px' }}>{`${textLengEn}/${props.maxLength}`}</Box> : <></>}
                    <TextInput
                        label={handleLabelEn()}
                        value={nameEn}
                        onChange={handleChangeNameEn}
                        fullWidth
                        maxLength={props.maxLength > 0 ? props.maxLength : 1000}
                    />
                </>
            }
            onSubmit={submit}
            onReset={props.onCancel}
            onClose={props.onCancel}
            handleClose
            autoResetModal={false}
            textBtnCancel={t('BUTTON.CANCEL')}
            textBtnConfirm={t('BUTTON.SAVE')}
        />
        // <PageModal
        //     isOpen
        //     title={handleTitle()}
        //     size='XS'
        //     handleClose={() => props.onCancel && props.onCancel()}
        //     onCancel={{ onClick: () => props.onCancel && props.onCancel() }}
        //     onSubmit={{ onClick: submit }}
        // >
        //     {/* <Col xl={12} xs={12} style={{}}>
        //         <Row style={{ marginTop: props.maxLength > 0 ? '10px' : '30px' }}>
        //             {props.maxLength > 0 ? <Box sx={{ fontWeight: 400, fontSize: '10px', color: '#808080', textAlign: 'end', marginLeft: '10px' }}>{`${textLength}/${props.maxLength}`}</Box> : <></>} */}
        //     <TextInput
        //         required
        //         helperText={errorName}
        //         label={handleLabelTh()}
        //         value={name}
        //         onChange={handleChangeName}
        //         fullWidth
        //         focus={true}
        //         maxLength={props.maxLength > 0 ? props.maxLength : 1000}
        //     />
        //     {/* </Row>
        //         <Row style={{ marginTop: props.maxLength > 0 ? '10px' : '30px' }}> */}
        //     {props.maxLength > 0 ? <Box sx={{ fontWeight: 400, fontSize: '10px', color: '#808080', textAlign: 'end', marginLeft: '10px' }}>{`${textLengEn}/${props.maxLength}`}</Box> : <></>}
        //     <TextInput
        //         label={handleLabelEn()}
        //         value={nameEn}
        //         onChange={handleChangeNameEn}
        //         fullWidth
        //         maxLength={props.maxLength > 0 ? props.maxLength : 1000}
        //     />
        //     {/* </Row> */}
        //     {/* </Col> */}
        // </PageModal>
    ) : (
        <></>
    )
}
